/**
 * Created by Jerker Nord on 2019-01-09.
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorSoundConfig} from "../../ThorSoundConfig";

export class ThorFreeSpinIntroController extends FreespinIntroController {

    private _fsWon:number = 0;
    private _isRestoreState:boolean;

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:ThorParsedGameData):boolean {
        this._isRestoreState = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;
        this._isRestoreFreespin = this._isRestoreState && data.freespinsLeft > 0;
        this._isFreespinWon = data.mode == ThorGameMode.SCATTER_RESPIN && data.nextMode == ThorGameMode.FREESPIN;
        this._fsWon = data.freespinsLeft;
        return this._isFreespinWon || this._isRestoreFreespin;
    }

    public start():void {
        if(this._isRestoreState == false) {
            ThorGameModuleConfig.thorFreeSpinBoxView.resetScatterMeter();
        }
        ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this._fsWon);
        super.start();
    }

    protected onCloseComplete():void {
        this.showKeypad();
        SlotGame.keypad.setZeroBetSpinCounter(this._fsWon);
        EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, true));
        SlotGame.sound.playAmbience(ThorSoundConfig.instance.FS_GAME_AMBIANCE);
        const delayTL:TimelineLite = new TimelineLite({
            delay : 1,
            onComplete : () => EventHandler.dispatchEvent(new GameEvent(ScreenEvent.SCREEN_CLOSED))
        });
        if(this._isRestoreState == false) {
            delayTL.add(() => ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this._fsWon - 1));
        }

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }
    }

    public static actuallyDoTransition() {
        ThorGameModuleConfig.thorExtraFSIconView.showExtraFSIconTL();
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : ThorGameMode.FREESPIN}));
    }
}